import React from 'react';
import Passengers from '../../../Passengers';
import styles from './paxSelectionStep.module.scss';
import { PaxSelectionStepProps } from '@msc-b2c/interfaces/interfaces';

const EMPTY_RESERVATIONS: { value: string }[] = [];

export const PaxSelectionStep: React.FC<PaxSelectionStepProps> = React.memo(
  ({
    isDrawerOpen,
    setPassengersToAdd,
    hasSelectedPassengers,
    confirmButtonLabel,
    confirmButtonLoadingLabel,
    confirmButtonLoadingLabelIcon,
    onNext,
    hideInternalCta,
    preselectedPassengers,
    headsUpMessage,
    disableCompletedDining,
    reservations = EMPTY_RESERVATIONS,
    hideLongDescription,
    isDiningButtonLoading,
    setIsDiningButtonLoading,
  }) => (
    <div className={styles['pax-selection-step']}>
      <Passengers
        isDrawerOpen={isDrawerOpen}
        setPassengersToAdd={setPassengersToAdd}
        isDining={true}
        diningConfirmLabel={confirmButtonLabel}
        diningConfirmLoadingLabel={confirmButtonLoadingLabel}
        diningConfirmLoadingLabelIcon={confirmButtonLoadingLabelIcon}
        diningButtonNext={onNext}
        hideDiningConfirmButton={hideInternalCta}
        hasSelectedPassengers={hasSelectedPassengers}
        preselectedPassengers={preselectedPassengers}
        headsUpMessage={headsUpMessage}
        disableCompletedDining={disableCompletedDining}
        reservations={reservations}
        isDiningButtonLoading={isDiningButtonLoading}
        setIsDiningButtonLoading={setIsDiningButtonLoading}
        hideLongDescription={hideLongDescription}
      />
    </div>
  )
);

export default PaxSelectionStep;
